<template>
  <ProfileCard
    :title="$t('components.profile.view.notifications.title')"
    :subtitle="$t('components.profile.view.notifications.subtitle')"
  >
    <OptIn
      :label="$t('components.profile.view.weekly.title')"
      :hint="$t('components.profile.view.weekly.subtitle')"
      type="switch"
      :checked="weeklySummaryEnabled"
      @update:checked="$emit('updateWeeklyDigest', $event)"
    />
    <NotificationSettings :buildings="buildings" class="w-full">
      <Button
        variant="secondary"
        type="grey"
        :size="maxSmall ? 'xl' : 'md'"
        @click="showEditNotifications = true"
        class="mt-2 mb-2 w-full"
      >
        {{ $t("components.profile.view.notifications.button") }}
      </Button>
    </NotificationSettings>
  </ProfileCard>
</template>

<script setup>
import { NotificationSettings } from "@/Pages/Notifications";
import { Button } from "@/SharedComponents/Buttons";
import { OptIn } from "@/SharedComponents/Switchers";
import { ProfileCard } from "@/SharedComponents/Profile/Partials";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["updateWeeklyDigest"]);

defineProps({
  buildings: { type: Array, required: true },
  weeklySummaryEnabled: { type: Boolean, required: true },
});
</script>
